import { render, staticRenderFns } from "./MaydayWebProductAttachedFilesCard.vue?vue&type=template&id=68ab95ee&scoped=true&"
import script from "./MaydayWebProductAttachedFilesCard.vue?vue&type=script&lang=js&"
export * from "./MaydayWebProductAttachedFilesCard.vue?vue&type=script&lang=js&"
import style0 from "./MaydayWebProductAttachedFilesCard.vue?vue&type=style&index=0&id=68ab95ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab95ee",
  null
  
)

export default component.exports